import { AppProviders, LibraryProviders } from "web/Providers"
import { BrowserRouter as Router } from "react-router-dom"
import { Controller } from "@hotwired/stimulus"
import { ErrorBoundary, ModalContainer } from "web/components"
import { render, unmountComponentAtNode } from "react-dom"
import ObjectOverview from "web/components/ObjectOverview"
import React, { Suspense } from "react"

export default class ComparableDealObjectOverviewController extends Controller {
  static values = {
    comparableDealId: Number,
    selectedOverviewId: Number,
    editPath: String,
    exportPath: String,
    canEdit: Boolean,
  }

  initialize() {
    global.React = React
  }

  connect() {
    render(
      <Suspense fallback={null}>
        <Router>
          <LibraryProviders>
            <AppProviders>
              <ErrorBoundary>
                <ObjectOverview
                  selectedOverviewId={this.selectedOverviewIdValue}
                  editPath={this.editPathValue}
                  exportPath={this.exportPathValue}
                  subjectType="sale"
                  subjectId={this.comparableDealIdValue}
                  canEdit={this.canEditValue}
                />
              </ErrorBoundary>
              <ModalContainer />
            </AppProviders>
          </LibraryProviders>
        </Router>
      </Suspense>,
      this.element
    )
  }

  disconnect() {
    unmountComponentAtNode(this.element)
  }
}
